const memberColors = [
    { borderColor: 'rgba(31, 119, 180)',  backgroundColor: 'rgba(31, 119, 180, 0.8)'  },  // blue
    { borderColor: 'rgba(255, 127, 14)',  backgroundColor: 'rgba(255, 127, 14, 0.8)'  },  // orange
    { borderColor: 'rgba(44, 160, 44)',   backgroundColor: 'rgba(44, 160, 44, 0.8)'   },  // green
    { borderColor: 'rgba(214, 39, 40)',   backgroundColor: 'rgba(214, 39, 40, 0.8)'   },  // red
    { borderColor: 'rgba(148, 103, 189)', backgroundColor: 'rgba(148, 103, 189, 0.8)' },  // purple
    { borderColor: 'rgba(140, 86, 75)',   backgroundColor: 'rgba(140, 86, 75, 0.8)'   },  // brown
    { borderColor: 'rgba(227, 119, 194)', backgroundColor: 'rgba(227, 119, 194, 0.8)' },  // pink
    { borderColor: 'rgba(188, 189, 34)',  backgroundColor: 'rgba(188, 189, 34, 0.8)'  },  // olive
    { borderColor: 'rgba(23, 190, 207)',  backgroundColor: 'rgba(23, 190, 207, 0.8)'  },  // teal
    { borderColor: 'rgba(127, 127, 127)', backgroundColor: 'rgba(127, 127, 127, 0.8)' },  // gray
];

export { memberColors };
